import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae1156e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "デイリートレーニングの設定", -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("戻る")

import { DailySettingLogic } from '@/logic/daily_setting/DailySettingLogic'
import { onMounted, computed, ref } from "vue";
import { useStore } from "vuex";
import { Category } from '@/types/category'
import { QuestionCategory } from '@/types/question_category'
import { QuestionCategoryRepository } from '@/repositories/QuestionCategoryRepository'
import CategoryListSelect from "@/components/common/categories/CategoryListSelect.vue"
import { useRoute } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const { get, save, dailySettingLoading, daily_setting } = DailySettingLogic();
const store = useStore();
const managerFlg = computed(() => store.state.login.manager_flg || store.state.login.project_owner_flg);

const categories = ref<QuestionCategory[]>([]);
let category = ref<Category>({ name: "All", id: -1, children: [], content_count: 0 })
onMounted(async () => {
  const repository = new QuestionCategoryRepository(Number(route.params.project_id));
  categories.value = await repository.getList();
  await get();
  for (let i = 0; i < categories.value.length; i++) {
    if (daily_setting.value?.question_category_id == categories.value[i].id) {
      category.value = categories.value[i]
    }
  }
})
const hundleSave = () => {
  if (daily_setting.value == undefined) {
    return
  }
  daily_setting.value.question_category_id = category.value.id
  save();
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_card, null, {
    default: _withCtx(() => [
      _hoisted_1,
      (_unref(daily_setting) && _unref(managerFlg))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_el_form, {
              model: _unref(daily_setting),
              "label-width": "200px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "出題範囲" }, {
                  default: _withCtx(() => [
                    _createVNode(CategoryListSelect, {
                      modelValue: _unref(category),
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(category) ? (category).value = $event : category = $event)),
                      categories: categories.value
                    }, null, 8, ["modelValue", "categories"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "優先度" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(daily_setting).sort_type,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(daily_setting).sort_type) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "新着順",
                          value: "id_desc"
                        }),
                        _createVNode(_component_el_option, {
                          label: "閲覧されていない順",
                          value: "pv_asc"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "検索範囲" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _unref(daily_setting).sort_size,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(daily_setting).sort_size) = $event)),
                      min: 1,
                      max: 200
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "1日の問題数" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: _unref(daily_setting).learning_count,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(daily_setting).learning_count) = $event)),
                      min: 1,
                      max: 10
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (hundleSave()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, {
                      to: { name: 'ProjectDailyLearning', params: { project_id: _ctx.$route.params.project_id } },
                      class: "button-link ml10"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, null, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512)), [
    [_directive_loading, _unref(dailySettingLoading)]
  ])
}
}

})